interface BlockErrorStateProps {
  title: string;
  message?: string | null;
  onRetry: () => void;
}

/** Spec 069 AC-A5 — a failed block says so and offers Retry; it never renders as a blank card. */
export default function BlockErrorState({ title, message, onRetry }: BlockErrorStateProps) {
  return (
    <div className="dash-block-error" role="alert">
      <div>
        <div className="dash-block-error__title">{title}</div>
        <div className="dash-block-error__msg">Couldn't load{message ? ` · ${message}` : ''}</div>
      </div>
      <button type="button" className="admin-btn admin-btn-outline admin-btn-sm" onClick={onRetry}>Retry</button>
    </div>
  );
}
